import * as React from "react";
import MenuList from "@mui/material/MenuList";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box, Button, Menu } from "@mui/material";
import { Add as AddIcon } from "@mui/icons-material";
import { useSelector } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import ImportExportIcon from "@mui/icons-material/ImportExport";

export default function ActionMenu({
  onSelectOption,
  forTable = "ManageLeads",
}) {
  const userDetails = useSelector(
    (state) => state.user.userDetails || { UserDetails: {} }
  );

  const userPermissions = userDetails ? userDetails.useraccess : [];

  const manageLeadsPermissions =
    userPermissions.find((perm) => perm.modulename === "Manage Leads") || {};

  const canExportManageLeads = manageLeadsPermissions?.export;
  const canImportManageLeads = manageLeadsPermissions?.import;

  const manageUsersPermissions =
    userPermissions.find((perm) => perm.modulename === "Manage Users") || {};

  const canExportManageUsers = manageUsersPermissions?.export;
  const canImportManageUsers = manageUsersPermissions?.import;
  const canAddManageUsers = manageUsersPermissions?.create;

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    if (forTable === "CommunicationTemplate") {
      onSelectOption("Add Template");
    }
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectOption = (selectedItem) => {
    handleClose();
    onSelectOption(selectedItem);
  };

  const getButtonLabel = () => {
    switch (forTable) {
      case "ManageUsers":
        return "Users";
      case "ManageLeads":
        return "Leads";
      case "CommunicationTemplate":
        return "Add Template";
      default:
        return "Action";
    }
  };

  const buttonWidth = forTable === "CommunicationTemplate" ? 180 : 110;

  const toolTipTitle = forTable === "CommunicationTemplate"
    ? "Add Communication Template"
    : `Import/Export/Add ${forTable === "ManageUsers" ? "User" : "Lead"}`;

  const renderMenuItems = () => {
    if (forTable === "ManageLeads") {
      return (
        <>
          <MenuItem
            sx={{
              ":hover": {
                backgroundColor: "#f1f4fa",
              },
            }}
            onClick={() => handleSelectOption("Add Lead")}
          >
            <ListItemIcon>
              <AddIcon fontSize="medium" />
            </ListItemIcon>
            <ListItemText>Add Lead</ListItemText>
          </MenuItem>
          {canImportManageLeads === "1" && (
            <MenuItem
              sx={{
                ":hover": {
                  backgroundColor: "#f1f4fa",
                },
              }}
              onClick={() => handleSelectOption("Import Lead")}
            >
              <ListItemIcon>
                <FileDownloadIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText>Import Lead</ListItemText>
            </MenuItem>
          )}
          {canExportManageLeads === "1" && (
            <MenuItem
              sx={{
                ":hover": {
                  backgroundColor: "#f1f4fa",
                },
              }}
              onClick={() => handleSelectOption("Export Lead")}
            >
              <ListItemIcon>
                <FileUploadIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText>Export Lead</ListItemText>
            </MenuItem>
          )}
        </>
      );
    }

    if (forTable === "ManageUsers") {
      return (
        <>
          {canAddManageUsers === "1" && (
            <MenuItem
              sx={{
                ":hover": {
                  backgroundColor: "#f1f4fa",
                },
              }}
              onClick={() => handleSelectOption("Add User")}
            >
              <ListItemIcon>
                <AddIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText>Add User</ListItemText>
            </MenuItem>
          )}
          {canImportManageUsers === "1" && (
            <MenuItem
              sx={{
                ":hover": {
                  backgroundColor: "#f1f4fa",
                },
              }}
              onClick={() => handleSelectOption("Import User")}
            >
              <ListItemIcon>
                <FileDownloadIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText>Import User</ListItemText>
            </MenuItem>
          )}
          {canExportManageUsers === "1" && (
            <MenuItem
              sx={{
                ":hover": {
                  backgroundColor: "#f1f4fa",
                },
              }}
              onClick={() => handleSelectOption("Export User")}
            >
              <ListItemIcon>
                <FileUploadIcon fontSize="medium" />
              </ListItemIcon>
              <ListItemText>Export User</ListItemText>
            </MenuItem>
          )}
        </>
      );
    }

    return null;
  };

  return (
    <Box>
      <Tooltip title={toolTipTitle} m={1} arrow>
        <Button
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          variant="filled"
          sx={{
            color: "#ffffff",
            backgroundColor: "#3A36DB",
            ":hover": {
              backgroundColor: "#3A36DB",
            },
            fontSize: {
              xs: 10,
              sm: 10,
              md: 12,
              lg: 12,
              xl: 12,
            },
            width: {
              xs: buttonWidth,
              sm: buttonWidth,
              md: buttonWidth,
              lg: buttonWidth,
              xl: buttonWidth,
            },
            height: {
              xs: 35,
              sm: 35,
              md: 35,
              lg: 35,
              xl: 35,
            },
          }}
        >
          <ImportExportIcon /> {getButtonLabel()}
        </Button>
      </Tooltip>
      {forTable !== "CommunicationTemplate" && (
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        <MenuList>{renderMenuItems()}</MenuList>
      </Menu>
      )}
    </Box>
  );
}
